import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M82.934 17.342a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M102.71 84.79a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#00D8D8" d="M8.5 76.91a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M76.714 78.732a1.5 1.5 0 0 1 0 2.122l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M64.598 78.732a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122M15.566 10.709a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V12.209a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M7 19.275a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H8.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M50.657 57.51v4.924a7.476 7.476 0 0 0 7.476 7.476h43.906c1.292 0 2.02-1.485 1.228-2.506L93.13 54.327l10.137-13.077c.792-1.02.064-2.506-1.228-2.506H68.971"
    />
    <path
      fill="#00D8D8"
      d="M66.844 57.509H26.11V26.342h40.735c1.174 0 2.128.953 2.128 2.128v26.91a2.13 2.13 0 0 1-2.128 2.129"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M26.109 24.092a2.25 2.25 0 0 1 2.25 2.25V96.87a2.25 2.25 0 0 1-4.5 0V26.34a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconGoalsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconGoalsInverted);
export default Memo;
